<template>
  <VDialog v-model="isVisible" width="350px" persistent attach="#LetsPage">
    <VeeForm ref="observer" v-slot="{ invalid,errors }">
      <VCard>
        <VCardTitle>
          {{ $t('C30101.C30101InsertRegularWithEndDialog.mSNQm9zHDq7y_IBvQ-lwA') }}
        </VCardTitle>
        <VCardText v-debug>
          <h3>dialogData</h3>
          {{dialogData}}
        </VCardText>
        <VCardText>
          <p class="mb-2">{{dialogData.courseInfoTitle}}</p>
          <table>
            <colgroup>
              <col style="width: fit-content;">
              <col style="width: fit-content;">
              <col style="width: max-content;">
            </colgroup>
            <tr>
              <td>{{ $t('C30101.C30101InsertRegularWithEndDialog.awcBp4BsnGY-Q4klwErNN') }}</td>
              <td>:</td>
              <td>
                {{dialogData.timeData}}
              </td>
            </tr>
            <tr>
              <td>{{ $t('C30101.C30101InsertRegularWithEndDialog.h3X2Fps0isi201Zu04NiU') }}</td>
              <td>:</td>
              <td>
                <InputRulesWrapper
                  v-slot="{ attrs }"
                  :rules="['min_value:1', 'max_value:30']"
                  :props="{ label: '全申込数' }"
                  vid="count"
                >
                  <div class="d-flex align-center w-fit" style="gap:8px;">
                    <span>
                      {{ $t('C30101.C30101InsertRegularWithEndDialog.jypAthP9zNWMtegm66eRP') }}
                    </span>
                    <div style="width:55px">
                      <VTextField
                        v-bind="{...attrs,errorMessages:null}"
                        v-model="outputData.count"
                        hide-details="auto"
                        variant="outlined"
                        type="number"
                        density="compact"
                      >
                      </VTextField>
                    </div>

                    <span>
                      {{ $t('C30101.C30101InsertRegularWithEndDialog.LEOWmW7IeNruONz2Th1QN') }}
                    </span>
                  </div>
                </InputRulesWrapper>
              </td>
            </tr>
          </table>
        </VCardText>
        <VCardText v-debug>
          <h3>outputData</h3>
          {{
            outputData
          }}
        </VCardText>
        <VCardText v-if="errors.count && errors.count.length">
          <span v-for="(error, index) in errors.count" :key="index" class="text-red">
            {{ error }}
          </span>
        </VCardText>
        <VCardActions>
          <VSpacer></VSpacer>
          <VBtn color="primary" size="small" :disabled="invalid" @click="emitOk">
            OK
          </VBtn>
          <VBtn variant="text" size="small" @click="emitCancel">
            {{ $t('common.cancel') }}
          </VBtn>
        </VCardActions>
      </VCard>
    </VeeForm>
  </VDialog>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import DialogMixin from '@/mixins/DialogMixin.js';
export default {
  components:{
  },
  mixins:[
    DialogMixin
  ],
  data() {
    return {
    };
  },
  methods:{
  }

}
</script>

<style scoped>
span {
  font-size: 1rem
}
.v-card__text{
  font-size: 1rem;
}
</style>
